import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface CollapsibleSection {
  title: string;
  items: string[];
}

export interface Announcement {
  id: string;
  title?: string;
  content: string;
  imageUrl?: string;
  createdAt?: string;
  publishDate?: string;
  changelogUrl?: string;
  layout?: 'long' | 'small';
  actionType?: 'link' | string;
  actionUrl?: string;
  collapsibleSections?: CollapsibleSection[];
}

// Бэкенд может вернуть либо объект анонса напрямую, либо null/пустой объект, либо формат {show: true/false, announcement?: {...}}
export type LastAnnouncementResponse = 
  | Announcement 
  | null 
  | { show: false }
  | { show: true; announcement: Announcement };

@Injectable({
  providedIn: 'root',
})
export class AnnouncementsApiService {
  private readonly baseUrl = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient) {}

  /**
   * Получить последний анонс
   */
  getLastAnnouncement(): Observable<LastAnnouncementResponse> {
    return this.http.get<LastAnnouncementResponse>(`${this.baseUrl}/announcements/last`);
  }

  /**
   * Отметить анонс как прочитанный
   */
  markAsRead(announcementId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/announcements/${announcementId}/read`, {});
  }
}
